import styled from 'styled-components';
export const Icon = styled.svg `
  height: 1.8rem;
  width: 1.8rem;
  margin-right: .5rem;
  display: inline;

  use {
    ${({ theme: { voucherStrapLineIcon } }) => voucherStrapLineIcon}
  }
`;
export const Message = styled.span `
    position: relative;
    top: 0.3rem;
`;
export const Element = styled.div `
  text-align: center;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  ${({ theme: { voucherStrapLine } }) => voucherStrapLine}
`;
export default {
    Element,
    Message,
    Icon,
};
